import React, { useEffect, useState } from 'react';
import { FilterMatchMode } from 'primereact/api';
import { Button } from 'primereact/button';
import { Column } from 'primereact/column';
import { DataTable } from 'primereact/datatable';
import { InputText } from 'primereact/inputtext';
import { Tooltip } from 'primereact/tooltip';
import { exportExcel } from './sc-approval-activity-details-service';
import { useGetScorecardApprovalActivityEmployeeQuery } from '../scorecardApprovalActivity/scorecardApprovalActivitySlice';
import MessageInfo from '../../../components/messageInfo/MessageInfo';
import { TOOLTIPDISPUTE } from '../../../constants';
import './scApprovalActivityDetails.scss';
import { datetimeToDate } from '../../../utils/dateFormat';

enum MetricReviewed {
    Reviewed = "Reviewed",
}
const TeamLead = "Team Lead";

interface ScorecardAprovalActivityEmployeeProps {
    inputyear?: number;
    inputmonth?: number;
    rowscorecardVersionID?: number;
    scorecardName: string;
}
export const SCApprovalActivityDetails = ({ inputyear, inputmonth, rowscorecardVersionID, scorecardName }: ScorecardAprovalActivityEmployeeProps) => {

    const { data: scorecardApprovalActivityEmployee } = useGetScorecardApprovalActivityEmployeeQuery(
        {
            year: inputyear,
            month: inputmonth,
            scorecardVersionId: rowscorecardVersionID,
        },
        { skip: !inputyear || !inputmonth || !rowscorecardVersionID }
    );


    const [seletedExpendedRowData, setSelectdExpendeRowData] = useState<any>([]);
    const [globalFilterValue, setGlobalFilterValue] = useState('');
    const [filters, setFilters] = useState({
        global: { value: null, matchMode: FilterMatchMode.CONTAINS },
    });
    const onGlobalFilterChange = (e: any) => {
        const value = e.target.value;
        const afilters = { ...filters };
        afilters.global.value = value;
        setFilters(afilters);
        setGlobalFilterValue(value);
    };

    useEffect(() => {
        setSelectdExpendeRowData(scorecardApprovalActivityEmployee?.data?.length > 0 ? scorecardApprovalActivityEmployee?.data : []);
    }, [scorecardApprovalActivityEmployee]);


    const handleExportClick = () => {
        const filteredColumnExport = seletedExpendedRowData?.map((row: any) => {
            return {
                ScorecardName: scorecardName,
                EmployeeNumber: row.employee_number,
                EmployeeName: row.employee_name,
                ApplicationRole: row.application_role_name,
                WorkedHours: row.worked_hours,
                RegularHours: row.regular_hours,
                OTHours: row.ot_hours,
                ApprovalStatus: row.approval_status_name,
                MetricReviewed: row.metric_reviewed,
                OpenDispute: row.open_disputes,
                AgentApproval: row.assoc_status_name,
                TeamLeadAssigned: row.tl_assigned,
                TeamLeadStatus: row.tl_status_name,
                ManagerAssigned: row.manager_assigned,
                ManagerStatus: row.manager_status_name,
                ManagerApprovalDate: row.manager_approval_date,
                PayoutTransmitDate: row.payout_transmit_date?datetimeToDate(row.payout_transmit_date):null
            }
        });
        exportExcel(filteredColumnExport);
    }

    const renderHeader = () => {
        return (
            <div className="flex justify-content-between exportexcel">
                <span className="p-input-icon-left">
                    <i className="pi pi-search" />
                    <InputText
                        value={globalFilterValue}
                        onChange={onGlobalFilterChange}
                        placeholder="Search"
                    />
                </span>
                <Button
                    type="button"
                    icon="pi pi-arrow-up me-2"
                    className="btn-export mr-2 me-2 float-end"
                    onClick={handleExportClick}
                    data-pr-tooltip="XLS"
                >
                    Export Scorecard
                </Button>
            </div>
        );
    };

    const header = renderHeader();
    const reviewedTemaplate = (row: any) => {
        const role = row.application_role_name;
        if (role === TeamLead)
            return <span>--</span>;

        const metricReviewed = row.metric_reviewed;
        if (metricReviewed === MetricReviewed.Reviewed)
            return <span style={{ color: '#2AA154' }}>{metricReviewed}</span>
        else
            return <span style={{ color: '#E23636' }}>{metricReviewed}</span>
    };

    const teamLeadAssignedTemaplate = (row: any) => {
        const role = row.application_role_name;
        if (role === TeamLead)
            return <span>--</span>;

        return <span>{row.tl_assigned}</span>
    };

    const disputeHeaderTemplate = () => {
        return <>
            <span>Open Disputes</span>
            <span>
                <Tooltip target=".question-circle" position="top" className='style-tooltip'>
                    <div className="tooltip-content">
                        <span style={{ minWidth: '5rem' }}>
                            {TOOLTIPDISPUTE}
                        </span>
                    </div>
                </Tooltip>
                <span className="question-circle">
                    <i className="pi pi-question" style={{ color: 'white' }} />
                </span></span>
        </>
    };

    if (seletedExpendedRowData.length > 0) {
        return (
            <div className="card mt-3 border-0">
                <div className="card-header border-0" style={{ backgroundColor: '#e0f0ff', padding: '15px', color: '#2B3A42' }}>
                    Scorecard Details
                </div>
                <div className="card-body p-0 align-middle text-center scorecardtable overflow-auto">
                    <DataTable
                        value={seletedExpendedRowData}
                        header={header}
                        className="mainTable"
                        id="sc-approval-detils"
                        rows={5}
                        rowsPerPageOptions={[5, 10, 25, 50]}
                        paginator={seletedExpendedRowData?.length > 5}
                        paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                        currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
                        filters={filters}
                    >
                        <Column
                            field="employee_name"
                            header="Employee"
                            headerStyle={{ width: '15rem' }}
                            bodyStyle={{ width: '15rem' }}
                            sortable
                            sortField="employee_name" />
                        <Column
                            field="application_role_name"
                            header="Role"
                            headerStyle={{ width: '8rem' }}
                            bodyStyle={{ width: '8rem' }}
                            sortable
                            sortField="application_role_name" />
                        <Column
                            field="worked_hours"
                            header="Worked Hours"
                            headerStyle={{ width: '8rem' }}
                            bodyStyle={{ width: '8rem' }}
                            sortable
                            sortField="worked_hours" />
                        <Column
                            field="regular_hours"
                            header="Regular Hours"
                            headerStyle={{ width: '8rem' }}
                            bodyStyle={{ width: '8rem' }}
                            sortable
                            sortField="regular_hours" />
                        <Column
                            field="ot_hours"
                            header="OT Hours"
                            headerStyle={{ width: '8rem' }}
                            bodyStyle={{ width: '8rem' }}
                            sortable
                            sortField="ot_hours" />
                        <Column
                            field="approval_status_name"
                            header="Approval Status"
                            headerStyle={{ width: '15rem' }}
                            bodyStyle={{ width: '15rem' }}
                            sortable
                            sortField="approval_status_name" />
                        <Column
                            field="metric_reviewed"
                            headerStyle={{ width: '15rem' }}
                            bodyStyle={{ width: '15rem' }}
                            header="Metrics Reviewed"
                            body={reviewedTemaplate}
                            sortable
                            sortField="metric_reviewed" />
                        <Column
                            field="open_disputes"
                            className='disputeCol'
                            headerStyle={{ width: '8rem' }}
                            bodyStyle={{ width: '8rem' }}
                            header={disputeHeaderTemplate}
                            sortable
                            sortField="open_disputes" />
                        <Column
                            field="assoc_status_name"
                            header="Agent Approval"
                            sortable
                            sortField="assoc_status_name"
                            headerStyle={{ width: '10rem' }}
                            bodyStyle={{ width: '10rem' }}
                        />
                        <Column
                            field="tl_assigned"
                            header="Team Lead Assigned"
                            body={teamLeadAssignedTemaplate}
                            sortable
                            headerStyle={{ width: '20rem' }}
                            bodyStyle={{ width: '20rem' }}
                            sortField="tl_assigned" />
                        <Column
                            field="tl_status_name"
                            header="Team Lead Approved"
                            sortable
                            headerStyle={{ width: '10rem' }}
                            bodyStyle={{ width: '10rem' }}
                            sortField="tl_status_name" />
                        <Column
                            field="manager_assigned"
                            header="Manager Assigned"
                            sortable
                            headerStyle={{ width: '20rem' }}
                            bodyStyle={{ width: '20rem' }}
                            sortField="manager_assigned" />
                        <Column
                            field="manager_status_name"
                            header="Manager Approved"
                            sortable
                            headerStyle={{ width: '8rem' }}
                            bodyStyle={{ width: '8rem' }}
                            sortField="manager_status_name" />
                        <Column
                            field="manager_approval_date"
                            header="Manager Approval Date"
                            sortable
                            headerStyle={{ width: '8rem' }}
                            bodyStyle={{ width: '8rem' }}
                            sortField="manager_approval_date" />
                        <Column
                            field="payout_transmit_date"
                            header="Payout Transmit Date"
                            body={(rowData) => rowData.payout_transmit_date ? datetimeToDate(rowData.payout_transmit_date) : null}
                            sortable
                            headerStyle={{ width: '8rem' }}
                            bodyStyle={{ width: '8rem' }}
                            sortField="payout_transmit_date" />

                    </DataTable>
                </div>
            </div>

        );
    }

    return (
        <div className="col-12">
            <MessageInfo title="" message="No Approval Activity found." rowHeight="50px" />
        </div>
    );
};
